module.exports = __webpack_public_path__ + "static/community-top-a8736db8e32e751072ded84a1263d38d.webp";